angular.module('mtic').constant('IAM_TRANSLATIONS',{
  "14455": {
    "id":14455,
    "item_id":"mtic2_IAM_translations",
    "en":"MathemaTIC - for cycles 3 and 4 and for secondary education. The environment is currently under maintainance and will be available from Friday 29th of September. In the meantime we advise you to update SCOLARIA and activate the IAM accounts of your students. Thank you for your patience.",
    "fr":"MathemaTIC - pour les cycles 3 et 4 et pour le cycle inférieur.\nL’environnement est en cours de maintenance et sera disponible à partir du vendredi 29 septembre. En attendant nous vous conseillons de mettre à jour SCOLARIA et d’activer les comptes IAM de vos élèves.\nMerci de votre patience.",
    "de":"MathemaTIC - für die Zyklen 3 und 4 und für den Untergrad der Sekundarstufe. Die Plattform wird gerade überarbeitet und wird vom 29. September an wieder zugänglich sein. In der Zwischenzeit empfehlen wir Ihnen, SCOLARIA zu aktualisieren und die IAM-Konten Ihrer Schüler zu aktivieren. Vielen Dank für Ihr Verständnis.",
    "pt":"Matemática - para os ciclos 3 e 4 e para o ensino secundário. O ambiente de aprendizagem encontra-se em manutenção e estará disponível a partir de sexta-feira, 29 de setembro. Entretanto, aconselhamos atualizar o SCOLARIA e ativar as contas IAM dos seus alunos. Obrigado pela sua paciência."
  },
  "14456": {
    "id":14456,
    "item_id":"mtic2_IAM_translations",
    "en":"Minimum System Requirements",
    "fr":"Configuration système minimale requise",
    "de":"Minimale Systemvoraussetzungen",
    "pt":"Requisitos de sistema mínimos"
  },
  "14457": {
    "id":14457,
    "item_id":"mtic2_IAM_translations",
    "en":"RECOMMENDED",
    "fr":"Recommandé",
    "de":"EMPFOHLEN",
    "pt":"RECOMANDADO"
  },
  "14458": {
    "id":14458,
    "item_id":"mtic2_IAM_translations",
    "en":"ALSO TESTING ON",
    "fr":"Bientôt compatible avec",
    "de":"AUCH GETESTET FÜR",
    "pt":"TAMBÉM TESTADO COM"
  },
  "14459": {
    "id":14459,
    "item_id":"mtic2_IAM_translations",
    "en":"COMING SOON",
    "fr":"PROCHAINEMENT",
    "de":"IN KÜRZE",
    "pt":"EM BREVE"
  },
  "14460": {
    "id":14460,
    "item_id":"mtic2_IAM_translations",
    "en":"with up to date Flash Player\n",
    "fr":"avec Flash Player mis à jour",
    "de":"mit aktualisiertem Flash Player",
    "pt":"com o Flash Player atualizado"
  },
  "14461": {
    "id":14461,
    "item_id":"mtic2_IAM_translations",
    "en":"GET THE APP\n",
    "fr":"Obtenez l'application",
    "de":"APP HERUNTERLADEN",
    "pt":"OBTENHA A APLICAÇÃO"
  },
  "14462": {
    "id":14462,
    "item_id":"mtic2_IAM_translations",
    "en":"Setting up IAM for Kids",
    "fr":"Configuration d'IAM pour les enfants",
    "de":"IAM for Kids einrichten",
    "pt":"Configurar IAM for Kids"
  },
  "14463": {
    "id":14463,
    "item_id":"mtic2_IAM_translations",
    "en":"Admin/Demo Login",
    "fr":"Connexion Admin / Demo",
    "de":"Einloggen Admin/Demo",
    "pt":"Login Admin/Demo"
  },
  "14464": {
    "id":14464,
    "item_id":"mtic2_IAM_translations",
    "en":"Download",
    "fr":"Télécharger",
    "de":"Download",
    "pt":"Download"
  },
  "14465": {
    "id":14465,
    "item_id":"mtic2_IAM_translations",
    "en":"Rights of use",
    "fr":"Droits d'utilisation",
    "de":"Nutzungsrechte",
    "pt":"Direitos de uso"
  },
  "14466": {
    "id":14466,
    "item_id":"mtic2_IAM_translations",
    "en":"Embed",
    "fr":"Intégrer",
    "de":"Einbetten",
    "pt":"Incorporar"
  },
  "14501": {
    "id":14501,
    "item_id":"mtic2_IAM_translations",
    "en":"dedicated video\n",
    "fr":"vidéo dédiée",
    "de":"Grafikspeicher",
    "pt":"vídeo dedicado"
  },
  "14502": {
    "id":14502,
    "item_id":"mtic2_IAM_translations",
    "en":"Fall 2017 Release\n",
    "fr":"Sortie prévue à l'automne 2017",
    "de":"Start Herbst 2017",
    "pt":"Lançamento outono 2017"
  },
  "14503": {
    "id":14503,
    "item_id":"mtic2_IAM_translations",
    "en":" or higher",
    "fr":"ou supérieur",
    "de":"oder höher",
    "pt":"ou superior"
  },
  "14524": {
    "id":14524,
    "item_id":"mtic2_IAM_translations",
    "en":"This website is optimized for modern browsers\nsuch as Google Chrome.\nPlease click on the link above and follow the installation instructions to upgrade to a compatible browser.",
    "fr":"Ce site est optimisé pour les navigateurs modernes tels que Google Chrome. Cliquez sur le lien ci-dessus et suivez les instructions d'installation pour passer à un navigateur compatible.",
    "de":"Diese Webseite ist optimiert für moderne Browser wie Google Chrome. Klicken Sie auf den Link unten, folgen Sie den Anweisungen zur Installation und aktualisieren Sie ihren Browser.",
    "pt":"Este site está otimizado para navegadores modernos como o Google Chrome.\nClique no link acima e siga as instruções de instalação para atualizar para um navegador compatível."
  }
});
